function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.74
}, React.createElement("g", {
  id: "2.2b-\\u2013-System-Admin-\\u2013-Images-\\u2013-Categories-tab",
  transform: "translate(-248.000000, -341.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M251.324547,346.682759 L256.971592,352.420464 C257.42236,352.877969 258.168012,352.892416 258.637051,352.452732 C259.10609,352.013049 259.120902,351.285733 258.670133,350.828227 C258.369621,350.523224 256.749524,348.876028 253.809842,345.886641 C256.749524,342.897247 258.369621,341.250048 258.670133,340.945044 C259.120902,340.487539 259.10609,339.760223 258.637051,339.32054 C258.168012,338.880856 257.42236,338.895303 256.971592,339.352808 L251.324547,345.090513 C251.10452,345.315877 250.987756,345.618736 251.001018,345.929673 C251.010567,346.2109 251.125703,346.478904 251.324547,346.682759 Z",
  id: "Path-Copy-5",
  transform: "translate(254.999377, 345.886636) rotate(-90.000000) translate(-254.999377, -345.886636) "
})));

var SvgDropdown = function SvgDropdown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDropdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropdown.4b5cb350.svg";
export { ForwardRef as ReactComponent };